import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {Modal} from "@material-ui/core";
import styles from "./RerunSTT.module.css";
import {useDispatch} from "react-redux";
import PuiButton from "../../../components/elements/PuiButton";
import PuiTypography from "../../../components/elements/PuiTypography";
import {RerunSTT} from "../../../store/actions/ExVideoActions";

interface RerunSTTComponentProps {
    videoId: number;
}

export default function RerunSTTComponent({videoId}: RerunSTTComponentProps) {

    const dispatch = useDispatch();
    const history = useHistory();

    // STT編集モーダル表示制御
    const [isOpenConfirmModal, ShowConfirmModal] = useState(false);
    
    const OpenConfirmModal = () => {
        ShowConfirmModal(true);
    };
    
    const CloseConfirmModal = () => {
        ShowConfirmModal(false);
    };
    
    const StartRerunSTT = () => {
        CloseConfirmModal();
        dispatch(RerunSTT(videoId));
        history.push("/contents");
    };
    
    return (
        <div>
            <div className={styles.rerunSTTIcon}>
                <PuiButton variant="contained" onClick={OpenConfirmModal} >STT再実行</PuiButton>
            </div>
    
            {/* STT再実行確認モーダル */}
            <Modal
                open={isOpenConfirmModal}
                onClose={CloseConfirmModal}
                className={styles.container}
            >
                <div className={styles.confirmModal}>
                    <ul className={styles.ul}>
                        <li style={{textAlign:"center"}}>
                            <PuiTypography size={16} bold={true} color={"black"}>STTを再実行しますか</PuiTypography>
                        </li>
                        <li style={{display:"flex"}}>
                            <div className={styles.verifyCancelButton}>
                                <PuiButton onClick={CloseConfirmModal}>キャンセル</PuiButton>
                            </div>
                            <div className={styles.verifyConfirmButton}>
                                <PuiButton onClick={StartRerunSTT}>STT再実行</PuiButton>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>        
        </div>
    );
}
    